import { ExpandMore, Visibility, VisibilityOff } from '@mui/icons-material'
import {
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material'

import React, { useState } from 'react'
import { PASSWORD_REGEX } from '../constants'

const PasswordInput = ({
  password,
  confirmedPassword,
  mismatchError,
  passwordReqError,
  setPassword,
  setConfirmedPassword,
  setMismatchError,
  setPasswordReqError,
  autoFocus,
}) => {
  const [passwordReqsExpanded, setPasswordReqsExpanded] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const checkPassword = () => {
    if (!password || !confirmedPassword) return
    if (password !== confirmedPassword) return setMismatchError(true)

    if (password.match(PASSWORD_REGEX) || password.length < 10) {
      // setPasswordReqsExpanded(true)
      return setPasswordReqError(true)
    }
  }

  return (
    <>
      <Accordion
        elevation={8}
        sx={{ boxShadow: 'none', backgroundColor: 'white', textAlign: 'left' }}
        expanded={passwordReqsExpanded}
        onChange={(_, isExpanded) => setPasswordReqsExpanded(isExpanded)}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>Password Requirements:</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ul className='requirements-list'>
            <li>At least 10 characters</li>
            <li>No spaces</li>
            <li>
              Allowed special characters:{' '}
              {`~ ! @ # $ % ^ * - _ = + [ { ] } / ; : , . ?`}
            </li>
          </ul>
          <div className='suggestion'>
            <span>
              We recommend using a mix of upper and lowercase letters, numbers,
              and symbols
            </span>
          </div>
        </AccordionDetails>
      </Accordion>

      <TextField
        fullWidth
        autoFocus={autoFocus}
        margin={'dense'}
        value={password}
        type={showPassword ? 'text' : 'password'}
        label='Password'
        onBlur={checkPassword}
        onChange={(e) => {
          setPasswordReqError(false)
          setMismatchError(false)
          setPassword(e.target.value)
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <TextField
        fullWidth
        margin={'dense'}
        value={confirmedPassword}
        type={showPassword ? 'text' : 'password'}
        label='Confirm Password'
        onBlur={checkPassword}
        onChange={(e) => {
          setPasswordReqError(false)
          setMismatchError(false)
          setConfirmedPassword(e.target.value)
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {mismatchError && (
        <Alert sx={{ mt: '8px' }} severity='error'>
          Passwords do not match
        </Alert>
      )}

      {passwordReqError && (
        <Alert sx={{ mt: '8px' }} severity='error'>
          Password does not meet requirements
        </Alert>
      )}
    </>
  )
}

export default PasswordInput
